import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import { Flex } from 'foundations-components/components/Flex';
import { gate } from 'hub-http/gates';
import userInfo from 'hub-http/userInfo';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useUsageTracker } from 'marketplace-ui-tracking';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const COPILOT_BUTTONS_GATE = gate('Marketplace:app-storefront-header-copilot-buttons');
export function CopilotButtons() {
  const [ungated, setUngated] = useState(false);
  const usageTracker = useUsageTracker();
  const appContext = useAppContext();
  useEffect(() => {
    // 1. We only want to show this on the in-app storefront
    // 2. userInfo() will make you sign-in on the public storefront
    if (appContext !== 'app') return;
    userInfo().then(({
      gates
    }) => {
      setUngated(gates.includes(COPILOT_BUTTONS_GATE));
    }).catch(() => {});
  }, [appContext]);
  if (!ungated) return null;
  const trackButtonClick = action => () => {
    usageTracker.track('storefront-interaction', {
      action,
      preferredLanguage: getLang()
    });
  };
  const renderButtons = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CopilotActionButton, {
      copilotAction: {
        openPromptTemplate: {
          id: 'ask_about_marketplace'
        }
      },
      disableTooltip: true,
      usageTracker: NOT_USING_TRACKER,
      text: unescapedText('appMarketplace.storefront.copilot.chat'),
      tooltip: unescapedText('appMarketplace.storefront.copilot.chat'),
      use: "tertiary",
      size: "small",
      onClick: trackButtonClick('click copilot chat button')
    }), /*#__PURE__*/_jsx(CopilotActionButton, {
      copilotAction: {
        openPromptTemplate: {
          id: 'summarize_app_features'
        }
      },
      disableTooltip: true,
      usageTracker: NOT_USING_TRACKER,
      text: unescapedText('appMarketplace.storefront.copilot.summarize'),
      tooltip: unescapedText('appMarketplace.storefront.copilot.summarize'),
      use: "tertiary",
      size: "small",
      onClick: trackButtonClick('click copilot summarize button')
    }), /*#__PURE__*/_jsx(CopilotActionButton, {
      copilotAction: {
        openPromptTemplate: {
          id: 'suggest_an_app'
        }
      },
      disableTooltip: true,
      usageTracker: NOT_USING_TRACKER,
      text: unescapedText('appMarketplace.storefront.copilot.suggest'),
      tooltip: unescapedText('appMarketplace.storefront.copilot.suggest'),
      use: "tertiary",
      size: "small",
      onClick: trackButtonClick('click copilot suggest button')
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MediaQueryView, {
      min: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: "400",
        justifyContent: "center",
        children: renderButtons()
      })
    }), /*#__PURE__*/_jsx(MediaQueryView, {
      max: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        marginBlockStart: "400",
        justifyContent: "center",
        children: renderButtons()
      })
    })]
  });
}